import * as React from 'react';

import Snapshot from './Snapshot';

interface Props {
  snaphotList: any[];
  setCurrentSnapTile: (snap: any) => void;
  fieldId: number;
  id: number;
  setCurrentDrawLayer: (layer: number[][]) => void;
}

const SnapshotList = ({
  snaphotList,
  setCurrentSnapTile,
  id,
  fieldId,
  setCurrentDrawLayer,
}: Props) => {

  return (
    <div className='snap_container d-flex justify-center align-center'>
      {
        id === fieldId && snaphotList.map((snapshot, key) => {
          return (
            <Snapshot
              setCurrentDrawLayer={setCurrentDrawLayer}
              setCurrentSnapTile={setCurrentSnapTile}
              snapNumber={key}
              snapshot={snapshot}
              key={key} />
          );
        })
      }
    </div>
  );
};

export default SnapshotList;
